import styled from 'styled-components';
import { palette } from 'styled-theme';

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 10px 20px 30px;
  min-width: 650px;
  max-width: 650px;
`;

export const LoadingModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: ${palette('background', 0)};
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const LoadingContent = styled.div`
  background: ${palette('background', 0)};
  border-radius: 16px;
  padding: 40px 60px;
  border: 1px solid ${palette('border', 0)};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;
